/* eslint-disable no-console */
import axios from 'axios';

import {
  EMISSIONS_OFFSET_VALIDATION_MESSAGE,
  isValidEmissionsOffset
} from '../../../components/Forms/Constants/CarbonOffset/CarbonOffsetKeyLabel';
import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
import {APIType, APITypeEnum} from '../../interface/tableAPIType';
import {getRouteIP, tableAPIMethod} from '../../utils/tableAPIMethod';

const emissionsOffsetsAreValid = (data: any): boolean => {
  if (Array.isArray(data?.projects)) {
    return data.projects.every((project: any) => {
      return isValidEmissionsOffset(project?.emissionsOffset);
    });
  }

  if (data && Object.prototype.hasOwnProperty.call(data, 'emissionsOffset')) {
    return isValidEmissionsOffset(data.emissionsOffset);
  }

  return true;
};

const carbonOffsetAPI = async (
  type: APIType,
  data: any = undefined,
  id: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  if (
    (type === APITypeEnum.POST_NEW || type === APITypeEnum.PUT) &&
    !emissionsOffsetsAreValid(data)
  ) {
    return {
      status: 'error',
      message: EMISSIONS_OFFSET_VALIDATION_MESSAGE
    };
  }

  try {
    const response = await axios.request({
      method: tableAPIMethod(type),
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.carbonOffset}/${getRouteIP(type, id)}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: data ?? {}
    });

    if (type === APITypeEnum.GET_ALL) {
      return response.data.data;
    } else {
      return response.data;
    }
  } catch (err: any) {
    console.log('err:', err);

    if (type === APITypeEnum.GET_ALL) {
      return undefined;
    }

    const responseData = err?.response?.data;
    const message =
      responseData && typeof responseData === 'object'
        ? responseData.message
        : undefined;

    return {
      status: 'error',
      message: message || 'Oops! Something went wrong'
    };
  }
};

export default carbonOffsetAPI;
